// state
let state = {
  lock: false
}

// getters
const getters = {
  lock: state => state.lock
}

// actions
const actions = {
  // open({ commit, state }, params) {
  close({ commit }) {
    commit('CLOSE')
  },
  open({ commit }) {
    commit('OPEN')
  }
}
// mutations
const mutations = {
  CLOSE(state) {
    state.lock = false
  },
  OPEN(state) {
    state.lock = true
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}